import Alert from "components/ui/Alert/Alert";
import { useView } from "features/view/context/ViewContext";
import Empty from "features/view/components/Empty/Empty";
import Trans from "features/translation/components/Trans";
import Loader from "components/ui/Loader/Loader";
import ProfileTeaser from "pages/Profile/ProfileTeaser";
import ViewPager from "features/view/components/Pager/ViewPager";

const ViewFavorites = () => {
  const { view, isLoading } = useView();

  if (!isLoading && !view) {
    return <Alert/>;
  }

  let content = view && view.map(
    (row, index) => <ProfileTeaser key={ index }
                                   gender={ row.field_profile_gender }
                                   name={ row.title }
                                   city={ row.field_profile_city }
                                   description={ row.field_profile_description }
                                   photo={ row.field_profile_photo }
                                   age={ row.field_profile_age }
                                   url={ row.view_node }
                                   variant={ 'dark' }/>);

  if (!content) {
    content = <Empty><Trans text="U heeft nog geen favoriete leden opgeslagen."/></Empty>;
  }

  return (
    <>
      <div className={ 'teasers-container--3col' }>
        { isLoading ? <Loader/> : content }
      </div>
      <ViewPager/>
    </>
  );
}

export default ViewFavorites;
